<div class="grid">
  @for(config of kpiCardConfig; track $index){
  <div class="col-12 md:col-6 xl:col-4">
    <kpi-card [cardConfig]="config"></kpi-card>
  </div>
  }

  <div class="col-12">
    <div class="flex justify-content-center gap-1">
      <button
        pButton
        [raised]="true"
        label="Μήνας"
        (click)="changePeriod(3)"
        [class.p-button-outlined]="activePeriod() == 3"
      ></button>
      <button
        pButton
        [raised]="true"
        label="Τρίμηνο"
        (click)="changePeriod(2)"
        [class.p-button-outlined]="activePeriod() == 2"
      ></button>
      <button
        pButton
        [raised]="true"
        label="Ετός"
        (click)="changePeriod(1)"
        [class.p-button-outlined]="activePeriod() == 1"
      ></button>
    </div>
  </div>
  <div class="col-12 lg:col-6">
    <div class="card h-full">
      <div class="flex align-items-center justify-content-between mb-4">
        <h5>Τελευταίες Ειδοποιήσεις</h5>
      </div>
      <p-table
        #dt
        [value]="alerts()"
        [paginator]="false"
        [rows]="5"
        dataKey="count"
      >
        <ng-template pTemplate="header">
          <tr>
            <th pResizableColumn>Ονοματεπώνυμο</th>
            <th pResizableColumn>Αριθμός Τηλεφώνου</th>
            <th pResizableColumn>Πόλη</th>
            <th pResizableColumn>Ημερομηνία</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-alert>
          <tr>
            <td>{{ alert.fullName }}</td>
            <td>{{ alert.phoneNumber }}</td>
            <td>{{ alert.city }}</td>
            <td>{{ alert.timestamp | date : "dd/MM/yyyy HH:mm" }}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="8">Δεν βρέθηκαν Ειδοποιήσεις</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
  <div class="col-12 lg:col-6">
    <div class="card h-full">
      <div class="flex align-items-center justify-content-between mb-4">
        <h5>Επείγουσες Ειδοποιήσεις ανά Πόλη</h5>
      </div>
      <p-table
        #dt
        [value]="cities$ | async"
        [paginator]="false"
        [rows]="5"
        dataKey="count"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>Πόλη</th>
            <th>Συνολικές Ειδοποιήσεις</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-cities>
          <tr>
            <td>{{ cities.city }}</td>
            <td>{{ cities.count }}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="8">Δεν βρέθηκαν πόλεις</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
